import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

export const getCurvesRecordingCursorTranslate = (frame: number) =>
	interpolate(
		frame,
		[
			6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 22, 23, 24, 25, 26, 27, 28,
			29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46,
			47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64,
			65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 80, 81, 82, 83, 84, 85,
			86, 87, 88, 89, 96, 97, 98, 99, 100, 101, 102, 115, 116, 117, 118, 119,
			120, 121, 122, 123, 124, 125, 126, 127, 128, 130, 131, 132, 169, 170, 171,
			172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186,
			187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201,
			202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216,
			217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231,
			232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246,
			247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261,
			262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276,
			277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291,
			292, 293, 294, 295, 296, 297, 298, 372, 373, 374, 375, 376, 377, 378, 379,
			380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394,
			395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409,
			410, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424,
			425, 426, 427, 428, 429, 437, 438,
		],
		[
			'-699.264705882353px 2758.125px',
			'-698.6691176470589px 2745.275735294118px',
			'-626.2610294117648px 2639.117647058824px',
			'-339.7058823529412px 2368.025735294118px',
			'200.08455882352942px 1880.4595588235295px',
			'536.625px 1502.1176470588236px',
			'724.202205882353px 1228.3786764705883px',
			'777.452205882353px 1105.389705882353px',
			'805.841911764706px 1019.5808823529412px',
			'807.1875px 1008.9816176470589px',
			'807.2316176470589px 1007.8786764705883px',
			'807.2316176470589px 1007.8676470588236px',
			'807.2316176470589px 1007.8676470588236px',
			'804.8492647058824px 1004.2941176470589px',
			'799.952205882353px 993.7500000000001px',
			'789.0441176470589px 976.0477941176471px',
			'765.8823529411765px 944.327205882353px',
			'746.7683823529412px 892.2463235294118px',
			'733.1470588235295px 821.4816176470589px',
			'714.9485294117648px 739.091911764706px',
			'686.1617647058824px 655.2573529411765px',
			'660.4852941176471px 592.2573529411765px',
			'650.2720588235295px 570.6948529411765px',
			'649.0147058823529px 568.1911764705883px',
			'648.6397058823529px 567.8823529411765px',
			'646.7867647058824px 567.6066176470589px',
			'646.6433823529412px 567.6066176470589px',
			'645.716911764706px 567.6066176470589px',
			'639.1102941176471px 568.7647058823529px',
			'621.2536764705883px 573.8051470588235px',
			'596.8455882352941px 581.7573529411765px',
			'568.1801470588235px 592.8860294117648px',
			'555.341911764706px 598.4558823529412px',
			'539.6691176470589px 605.3492647058824px',
			'530.1727941176471px 609.2205882352941px',
			'517.2022058823529px 614.2058823529412px',
			'511.952205882353px 615.6617647058824px',
			'510.98161764705884px 615.9595588235295px',
			'510.39705882352945px 616.1691176470589px',
			'509.1727941176471px 616.4889705882354px',
			'508.4117647058824px 616.7095588235295px',
			'507.1213235294118px 617.5698529411765px',
			'505.2352941176471px 619.4117647058824px',
			'502.55514705882354px 623.5367647058824px',
			'500.9669117647059px 626.7904411764706px',
			'500.83455882352945px 627.3639705882354px',
			'500.7352941176471px 627.6397058823529px',
			'500.5808823529412px 627.7830882352941px',
			'500.4044117647059px 628.3125px',
			'500.4044117647059px 628.6875px',
			'500.4044117647059px 628.9632352941177px',
			'500.3933823529412px 629.7132352941177px',
			'500.0514705882353px 631.1470588235295px',
			'500.0514705882353px 631.7205882352941px',
			'500.0514705882353px 631.7867647058824px',
			'500.0514705882353px 632.0845588235295px',
			'500.0514705882353px 632.404411764706px',
			'500.0514705882353px 632.7242647058824px',
			'500.0514705882353px 633.3639705882354px',
			'500.0514705882353px 633.9926470588235px',
			'500.0514705882353px 635.0183823529412px',
			'499.9963235294118px 635.966911764706px',
			'499.7536764705883px 637.0147058823529px',
			'499.7536764705883px 638.1507352941177px',
			'499.6433823529412px 638.7904411764706px',
			'499.35661764705884px 639.3529411764706px',
			'499.2352941176471px 639.5735294117648px',
			'499.2352941176471px 639.5735294117648px',
			'499.2352941176471px 639.6727941176471px',
			'499.2352941176471px 640.2352941176471px',
			'499.2352941176471px 640.6654411764706px',
			'499.2352941176471px 640.7426470588235px',
			'499.2352941176471px 640.7867647058824px',
			'499.2352941176471px 640.7867647058824px',
			'498.8382352941177px 641.5588235294118px',
			'498.80514705882354px 641.7573529411765px',
			'498.80514705882354px 642.8161764705883px',
			'498.80514705882354px 642.8161764705883px',
			'498.80514705882354px 642.8272058823529px',
			'498.7389705882353px 643.3345588235295px',
			'498.3529411764706px 644.1838235294118px',
			'498.02205882352945px 645.1654411764706px',
			'497.84558823529414px 645.8823529411765px',
			'497.84558823529414px 646.0698529411765px',
			'497.84558823529414px 646.0698529411765px',
			'497.84558823529414px 646.1360294117648px',
			'497.84558823529414px 646.5551470588235px',
			'497.7132352941177px 646.875px',
			'497.514705882353px 647.3051470588235px',
			'497.514705882353px 648px',
			'497.514705882353px 648.5735294117648px',
			'497.514705882353px 648.904411764706px',
			'497.514705882353px 649.1801470588235px',
			'497.514705882353px 649.1911764705883px',
			'497.514705882353px 649.2352941176471px',
			'497.6029411764706px 649.5551470588235px',
			'497.81250000000006px 649.8529411764706px',
			'497.81250000000006px 649.9742647058824px',
			'497.81250000000006px 649.9742647058824px',
			'497.81250000000006px 650.2720588235295px',
			'497.81250000000006px 650.3823529411765px',
			'497.81250000000006px 650.3823529411765px',
			'497.81250000000006px 650.2279411764706px',
			'497.5036764705883px 649.1470588235295px',
			'496.50000000000006px 647.5477941176471px',
			'495.9264705882353px 646.3455882352941px',
			'495.56250000000006px 645.5514705882354px',
			'495.02205882352945px 644.6029411764706px',
			'494.7132352941177px 644.0514705882354px',
			'494.68014705882354px 643.8860294117648px',
			'494.3382352941177px 643.5110294117648px',
			'493.9742647058824px 642.7941176470589px',
			'493.6654411764706px 642.1764705882354px',
			'493.0367647058824px 641.3492647058824px',
			'492.22058823529414px 640.5330882352941px',
			'491.65808823529414px 639.9705882352941px',
			'491.09558823529414px 639.5955882352941px',
			'490.4558823529412px 639.0110294117648px',
			'489.827205882353px 638.3823529411765px',
			'489.30882352941177px 638.0735294117648px',
			'489.04411764705884px 637.5551470588235px',
			'489.01102941176475px 637.5551470588235px',
			'488.8014705882353px 637.4227941176471px',
			'488.2389705882353px 636.8602941176471px',
			'487.0698529411765px 636.1102941176471px',
			'485.4264705882353px 635.1617647058824px',
			'484.2573529411765px 634.5330882352941px',
			'483.03308823529414px 633.9154411764706px',
			'482.5257352941177px 633.4522058823529px',
			'481.52205882352945px 632.779411764706px',
			'480.7058823529412px 632.1838235294118px',
			'479.81250000000006px 631.4227941176471px',
			'478.6323529411765px 630.4301470588235px',
			'477.24264705882354px 629.4485294117648px',
			'475.5882352941177px 628.2352941176471px',
			'474.6286764705883px 627.1323529411765px',
			'473.7794117647059px 626.2610294117648px',
			'473.29411764705884px 625.7757352941177px',
			'472.764705882353px 625.2463235294118px',
			'472.4448529411765px 625.0257352941177px',
			'471.99264705882354px 624.75px',
			'471.99264705882354px 624.6838235294118px',
			'470.9779411764706px 623.4264705882354px',
			'470.0514705882353px 622.5661764705883px',
			'468.78308823529414px 621.5514705882354px',
			'467.9558823529412px 620.9889705882354px',
			'466.62132352941177px 620.2941176470589px',
			'465.40808823529414px 619.3345588235295px',
			'464.5698529411765px 618.5735294117648px',
			'463.8198529411765px 617.8786764705883px',
			'463.0367647058824px 617.0845588235295px',
			'462.0661764705883px 616.2463235294118px',
			'461.5808823529412px 615.3970588235295px',
			'460.70955882352945px 614.4264705882354px',
			'460.16911764705884px 613.8860294117648px',
			'459.8823529411765px 613.3345588235295px',
			'459.41911764705884px 612.6948529411765px',
			'458.44852941176475px 611.9007352941177px',
			'458.44852941176475px 611.9007352941177px',
			'457.8639705882353px 611.1397058823529px',
			'457.0698529411765px 610.3455882352941px',
			'456.0882352941177px 609.3639705882354px',
			'455.09558823529414px 608.6911764705883px',
			'454.577205882353px 608.404411764706px',
			'454.2352941176471px 607.8088235294118px',
			'453.639705882353px 607.4889705882354px',
			'452.64705882352945px 606.8382352941177px',
			'452.07352941176475px 606.5955882352941px',
			'450.94852941176475px 606.2205882352941px',
			'450.2977941176471px 605.8125px',
			'449.0294117647059px 605.0514705882354px',
			'447.02205882352945px 604.0477941176471px',
			'446.3161764705883px 603.6176470588235px',
			'445.05882352941177px 603.2647058823529px',
			'444.1654411764706px 602.6029411764706px',
			'443.09558823529414px 601.7205882352941px',
			'441.79411764705884px 600.7941176470589px',
			'440.7794117647059px 599.8897058823529px',
			'440.1948529411765px 599.3933823529412px',
			'438.94852941176475px 598.1470588235295px',
			'437.65808823529414px 596.8566176470589px',
			'436.36764705882354px 595.2683823529412px',
			'435.5404411764706px 594.1654411764706px',
			'434.5698529411765px 593.0073529411765px',
			'433.4448529411765px 592.091911764706px',
			'432.5625px 591.0772058823529px',
			'431.8014705882353px 590.029411764706px',
			'431.2389705882353px 589.1801470588235px',
			'430.6764705882353px 588.5183823529412px',
			'429.7058823529412px 587.5477941176471px',
			'429.3639705882353px 586.7536764705883px',
			'428.6911764705883px 585.8161764705883px',
			'427.764705882353px 585.1985294117648px',
			'426.94852941176475px 584.6029411764706px',
			'426.5294117647059px 584.0735294117648px',
			'426.04411764705884px 583.4558823529412px',
			'425.44852941176475px 583.0147058823529px',
			'424.80882352941177px 582.4522058823529px',
			'423.8492647058824px 581.7683823529412px',
			'423.19852941176475px 580.8639705882354px',
			'422.25px 579.9154411764706px',
			'421.5661764705883px 579.2316176470589px',
			'420.2867647058824px 578.0183823529412px',
			'419.30514705882354px 577.1691176470589px',
			'418.5882352941177px 576.4522058823529px',
			'417.95955882352945px 575.6139705882354px',
			'416.0625px 573.3970588235295px',
			'414.80514705882354px 572.1397058823529px',
			'413.9889705882353px 571.3235294117648px',
			'412.9632352941177px 570.3308823529412px',
			'411.3198529411765px 569.029411764706px',
			'410.2389705882353px 568.3014705882354px',
			'409.014705882353px 567.5514705882354px',
			'408.1875px 566.8786764705883px',
			'407.1286764705883px 566.0404411764706px',
			'406.15808823529414px 565.3566176470589px',
			'404.86764705882354px 564.3970588235294px',
			'403.69852941176475px 563.779411764706px',
			'402.80514705882354px 563.1617647058824px',
			'401.5477941176471px 562.2352941176471px',
			'400.7757352941177px 561.8051470588235px',
			'400.0257352941177px 561.3970588235294px',
			'399.22058823529414px 560.7683823529412px',
			'398.49264705882354px 560.1727941176471px',
			'398.2389705882353px 559.9191176470589px',
			'397.9742647058824px 559.654411764706px',
			'397.6323529411765px 559.3125px',
			'397.34558823529414px 559.0257352941177px',
			'396.7058823529412px 559.0036764705883px',
			'396.452205882353px 558.8713235294118px',
			'396px 558.8713235294118px',
			'396px 558.8713235294118px',
			'390.3198529411765px 568.1470588235295px',
			'365.5698529411765px 610.6654411764706px',
			'327.5625px 674.6029411764706px',
			'264.0992647058824px 770.1507352941177px',
			'180.1654411764706px 886.5992647058824px',
			'81px 1015.7205882352941px',
			'7.444852941176471px 1112.172794117647px',
			'-162.06617647058823px 1367.6360294117649px',
			'-223.98529411764707px 1492.5330882352941px',
			'-291.2977941176471px 1639.0257352941178px',
			'-335.9779411764706px 1728.6617647058824px',
			'-383.12867647058823px 1822.3345588235295px',
			'-419.5257352941177px 1920.1764705882354px',
			'-457.0036764705883px 2018.294117647059px',
			'-492.98161764705884px 2106.9375px',
			'-530.5477941176471px 2206.3014705882356px',
			'-561.4080882352941px 2307.452205882353px',
			'-575.7463235294118px 2363.2720588235297px',
			'-585.6176470588235px 2395.6764705882356px',
			'-598.2904411764706px 2425.3786764705883px',
			'-607.3676470588235px 2448.8823529411766px',
			'-613.5px 2472.3198529411766px',
			'-615.0330882352941px 2482.9411764705883px',
			'-615.4080882352941px 2486.2720588235297px',
			'-618.2867647058824px 2496.0220588235297px',
			'-620.404411764706px 2502.341911764706px',
			'-638.5588235294118px 2548.4117647058824px',
			'-649.5661764705883px 2575.4889705882356px',
			'-661.3897058823529px 2610.1102941176473px',
			'-665.4816176470589px 2625.970588235294px',
			'-670.7205882352941px 2651.2279411764707px',
			'-672.4301470588235px 2659.8970588235297px',
			'-672.6507352941177px 2664.529411764706px',
			'-672.6507352941177px 2671.1470588235297px',
			'-673.125px 2676.055147058824px',
			'-673.5992647058824px 2679.7279411764707px',
			'-674.0955882352941px 2687.150735294118px',
			'-674.625px 2696.889705882353px',
			'-675.4632352941177px 2704.621323529412px',
			'-676.9301470588235px 2714.261029411765px',
			'-677.3382352941177px 2721.3529411764707px',
			'-677.8566176470589px 2730.6727941176473px',
			'-678.3198529411765px 2735.2389705882356px',
			'-679.2573529411765px 2739.794117647059px',
			'-680.1838235294118px 2744.1286764705883px',
			'-680.8786764705883px 2747.9117647058824px',
			'-682.5661764705883px 2753.7904411764707px',
			'-685.9852941176471px 2761.279411764706px',
			'-687.1102941176471px 2763.5845588235297px',
			'-688.764705882353px 2768.029411764706px',
			'-690.3529411764706px 2772.308823529412px',
			'-692.1617647058824px 2777.558823529412px',
			'-694.2904411764706px 2783.150735294118px',
			'-696.2977941176471px 2787.9375px',
			'-697.202205882353px 2791.2242647058824px',
			'-697.389705882353px 2792.404411764706px',
			'-697.466911764706px 2792.6470588235297px',
			'-697.466911764706px 2792.6470588235297px',
			'-697.466911764706px 2793.055147058824px',
		],
		{
			extrapolateLeft: 'clamp',
			extrapolateRight: 'clamp',
		},
	);

export const ExploreCurvesRecording20261027Composition = () => {
	const {fps} = useVideoConfig();
	// The recording and cursor keyframes use a 60 fps source clock.
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(492 / 60) * fps}
			style={{
				width: 958,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/explore-remotion/curves-source-2026-10-27-aafaec4fc822.mp4"
				durationInFrames={(492 / 60) * fps}
				muted
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[6, 10, 13, 14, 379, 386, 387],
					['auto', 'default', 'auto', 'default', 'auto', 'default', 'auto'],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 151, 346, 434, 439],
						[
							2.823529411764706, 2.5411764705882356, 2.823529411764706,
							2.5411764705882356, 2.823529411764706,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: getCurvesRecordingCursorTranslate(frame),
				}}
			/>
		</AbsoluteFill>
	);
};
